'use client';

import { type ReactNode, createContext, useContext, useMemo } from 'react';

import type { BlogPost } from '@/types/blog.type';

interface LatestBlogPostsContextValue {
  posts: BlogPost[];
}

const LatestBlogPostsContext = createContext<LatestBlogPostsContextValue | null>(null);

interface LatestBlogPostsProviderProps {
  posts: BlogPost[];
  children: ReactNode;
}

export const LatestBlogPostsProvider = ({ posts, children }: LatestBlogPostsProviderProps) => {
  const value = useMemo(() => ({ posts }), [posts]);

  return <LatestBlogPostsContext.Provider value={value}>{children}</LatestBlogPostsContext.Provider>;
};

export const useLatestBlogPosts = (): BlogPost[] => {
  const context = useContext(LatestBlogPostsContext);

  return context?.posts ?? [];
};
